export enum MatchEvents {
    Kickoff = 1,
    Lineout = 2,
    Scrum = 3,
    TwentyTwo = 4,
    GoalLineDropOut = 5,
    FreeKick = 6,
    PenaltyKickForTouch = 7,
    PenaltyTapAndGo = 8,
    ShotAtGoalPenalty = 9,
    ShotAtGoalConversion = 10,
    Try = 11,
    ShotAtGoalPenaltySuccess = 12,
    ShotAtGoalPenaltyMiss = 13,
    ShotAtGoalConversionSuccess = 14,
    ShotAtGoalConversionMiss = 15,
    PenaltyTry = 16,
    Penalty = 17,
    QuickLineout = 18,
    ThreeManLineout = 19,
    FourManLineout = 20,
    FiveManLineout = 21,
    SixManLineout = 22,
    SevenManLineout = 23,
    DropgoalSuccess = 24,
    DropgoalMiss = 25,
    EightPlusManLineout = 26,
}